export default "__VITE_ASSET__BfLtdrlN__"